export default "__VITE_ASSET__15873fce__"